module.exports = __webpack_public_path__ + "static/img/ks3.45cc494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/ks3.png
// module id = Ur51
// module chunks = 19